import axios from "axios";
import { refreshAdminToken } from "../admin/adminSession";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const consoleApi = axios.create({ baseURL: API });

consoleApi.interceptors.request.use((cfg) => {
  // Console shares the existing admin token (same require_admin guard).
  const token = localStorage.getItem("heritage-admin-token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Expired access token + "Remember this login" → silently refresh once and retry.
// Otherwise bounce to the admin login.
consoleApi.interceptors.response.use(
  (res) => res,
  async (err) => {
    const status = err?.response?.status;
    const cfg = err?.config;
    if (status === 401 && cfg && !cfg._adminRefreshed) {
      const token = await refreshAdminToken();
      if (token) {
        cfg._adminRefreshed = true;
        cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${token}` };
        return consoleApi(cfg);
      }
    }
    if (status === 401 || status === 403) {
      const here = window.location.pathname;
      if (here.startsWith("/console") && !here.includes("/admin/login")) {
        localStorage.removeItem("heritage-admin-token");
        window.location.replace(`/admin/login?next=${encodeURIComponent(here)}`);
      }
    }
    return Promise.reject(err);
  }
);

export default consoleApi;
